import React from 'react'

const ChevronIcon = props => (
  <svg {...props} fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="m1.91421356.5 4.94978644 4.949 4.9497085-4.949c.3905243-.39052429 1.0236893-.39052429 1.4142136 0s.3905243 1.02368927 0 1.41421356l-5.65685429 5.65685425c-.15020165.15020165-.33629689.24263344-.53067527.27729536l-.11740012.01386476h-.11806278c-.23590466-.01386476-.46783341-.11091814-.64807539-.29116012l-5.65685425-5.65685425c-.39052429-.39052429-.39052429-1.02368927 0-1.41421356s1.02368927-.39052429 1.41421356 0z" />
  </svg>
)

export default ChevronIcon
